module.exports = __webpack_public_path__ + "static/media/nativityofblessedvirgin.07a2a525.webp";